var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-error"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 61
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    clipPath: "url(#clip-error)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M30.875,3.375a27.5,27.5,0,1,0,27.5,27.5A27.5,27.5,0,0,0,30.875,3.375Zm6.968,37.456-6.968-6.968-6.968,6.968a2.113,2.113,0,1,1-2.988-2.988l6.968-6.968-6.968-6.968a2.113,2.113,0,0,1,2.988-2.988l6.968,6.968,6.968-6.968a2.113,2.113,0,0,1,2.988,2.988l-6.968,6.968,6.968,6.968a2.123,2.123,0,0,1,0,2.988A2.1,2.1,0,0,1,37.843,40.831Z",
    transform: "translate(1.625 -0.375)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e41286d5dbb7a3ce8750d625a39b5635.svg";
export { ForwardRef as ReactComponent };